export default "__VITE_ASSET__CZFi_NpN__"